// src/frontend/components/room/EditorSimple.jsx
import React, {useEffect, useRef, useState} from 'react';
import {useRoom} from '../../context/RoomContext';
import {socket} from '../../lib/socket';
import {SOCKET_EVENTS} from "../../constants/events.js";

export default function EditorSimple() {
    const {roomId} = useRoom();
    const [text, setText] = useState('');
    const textareaRef = useRef(null);
    const isRemoteUpdate = useRef(false);

    useEffect(() => {
        if (!roomId) return;

        // Dein Backend sendet 'updateText' beim Join oder bei Änderungen
        socket.on(SOCKET_EVENTS.UPDATE_TEXT, (newText) => {
            console.log('on', newText)
            isRemoteUpdate.current = true;
            setText(newText || '');

            // Cursor-Position halbwegs erhalten
            const ta = textareaRef.current;
            if (ta) {
                const start = ta.selectionStart;
                const end = ta.selectionEnd;
                setTimeout(() => ta.setSelectionRange(start, end), 0);
            }

            setTimeout(() => isRemoteUpdate.current = false, 10);
        });

        // Beim Join könnte dein Backend schon 'updateText' senden – falls nicht, hier explizit anfragen (wenn nötig)
        // socket.emit('getInitialText', { roomId });  // Falls du so etwas hast; ansonsten startet es leer

        return () => {
            socket.off(SOCKET_EVENTS.UPDATE_TEXT);
        };
    }, [roomId]);

    const handleChange = (e) => {
        const newText = e.target.value;
        setText(newText);

        if (!isRemoteUpdate.current && roomId) {
            // Dein Backend erwartet 'textChange'
            socket.emit(SOCKET_EVENTS.TEXT_CHANGE, {roomId, text: newText});
        }
    };

    return (
        <div
            className="bg-white/80 dark:bg-white/5 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/20 p-6 h-[500px] flex flex-col">
            <h3 className="text-xl font-bold mb-4 text-gray-800 dark:text-white">Gemeinsamer Text</h3>
            <textarea
                ref={textareaRef}
                value={text}
                onChange={handleChange}
                placeholder="Hier könnt ihr gemeinsam schreiben..."
                className="flex-1 w-full p-4 bg-gray-50 dark:bg-gray-900/50 border border-gray-300 dark:border-gray-600 rounded-xl
                   focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none font-mono text-base
                   text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400"
                spellCheck="false"
            />
        </div>
    );
}